import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface FavoriteItem {
  id: number;
  title?: string;
  name?: string;
  poster_path?: string;
  vote_average?: number;
  type: "movie" | "tv";
}

interface FavoritesState {
  items: FavoriteItem[];
}

const initialState: FavoritesState = {items: []};

const favoritesSlice = createSlice({
  name: "favorites",
  initialState,
  reducers: {
    addToFavorites(state, action: PayloadAction<FavoriteItem>) {
      if (!state.items.find((i) => i.id === action.payload.id)) {
        state.items.unshift(action.payload);
      }
    },
    removeFromFavorites(state, action: PayloadAction<number>) {
      state.items = state.items.filter((i) => i.id !== action.payload);
    },
    clearFavorites(state) {
      state.items = [];
    },
  },
});

export const {addToFavorites, removeFromFavorites, clearFavorites} = favoritesSlice.actions;
export default favoritesSlice.reducer;
